import React from "react";
import SEOPage from "../Components/SEOPage";
import Navbar from "../Components/Navbar";
import ScrollReveal from "../Components/ScrollReveal";
import SiteFooter from "../Components/SiteFooter";
import Chatbox from "../Components/Chatbox";
import CustomHero from "../Components/custom/CustomHero";
import WhyChooseCustom from "../Components/custom/WhyChooseCustom";
// import CustomProcess from "../Components/custom/CustomProcess";
// import TechAndWork from "../Components/custom/TechAndWork"; // tech stack + "Our work" side by side (old layout)
import TechStack from "../Components/custom/TechStack";
import CustomCta from "../Components/custom/CustomCta";
import HowWeWork from "../Components/home/HowWeWork";
import TrustedIndustries from "../Components/home/TrustedIndustries";

// Redesigned (Tailwind) page for /service/custom-website-design-development-solutions.
const CustomWebsitePage = () => (
  <div>
    <SEOPage
      title="Custom Website Design & Development Company in Noida | DataMetricks"
      description="DataMetricks builds tailor-made custom websites that are fast, secure, scalable, SEO friendly and designed around your brand and business goals."
      canonicalUrl="https://www.datametricks.com/service/custom-website-design-development-solutions"
    />

    <Navbar />
    <ScrollReveal />

    {/* Every Tailwind utility is scoped to `.tw` (see tailwind.config.js) */}
    <main className="tw">
      <CustomHero />
      <WhyChooseCustom />
      <HowWeWork />

      {/* <CustomProcess /> */}
      <TechStack />
      <TrustedIndustries />
      {/* <CustomCta /> */}

    </main>

    <Chatbox />
    <SiteFooter />
  </div>
);

export default CustomWebsitePage;
